import api from '@/lib/api';
import { DashboardStats, DailySummary, DateRange } from '@/types/dashboard';

class DashboardApiService {
  // Obter estatísticas do dashboard
  async getDashboardStats(dateRange?: DateRange, clientId?: number): Promise<DashboardStats> {
    const params: any = {};
    
    if (dateRange) {
      params.startDate = dateRange.startDate;
      params.endDate = dateRange.endDate;
    }
    
    // Se clientId for fornecido (para admins), adicionar aos parâmetros
    if (clientId) {
      params.client_id = clientId;
    }

    console.log('📊 [DashboardApi] Fazendo requisição para /client-dashboard/stats com params:', params);
    
    try {
      console.log('📊 [DashboardApi] Iniciando requisição para /client-dashboard/stats');
      console.log('📊 [DashboardApi] Parâmetros:', params);
      
      // Usar endpoint normal com autenticação
      const response = await api.get('/client-dashboard/stats', { params });
      console.log('📊 [DashboardApi] Resposta completa:', response);
      console.log('📊 [DashboardApi] Tipo da resposta:', typeof response);
      console.log('📊 [DashboardApi] Resposta data:', response.data);
      console.log('📊 [DashboardApi] Resposta success:', response.success);
      console.log('📊 [DashboardApi] Resposta data.data:', response.data?.data);
      
      // A API retorna { success: true, data: { ... } }
      if (response.success && response.data) {
        console.log('📊 [DashboardApi] Dados extraídos:', response.data);
        return response.data;
      } else {
        console.error('❌ [DashboardApi] Resposta inválida:', response);
        console.error('❌ [DashboardApi] Estrutura da resposta:', {
          hasSuccess: 'success' in response,
          hasData: 'data' in response,
          responseKeys: Object.keys(response)
        });
        throw new Error('Resposta inválida da API');
      }
    } catch (error) {
      console.error('❌ [DashboardApi] Erro na requisição:', error);
      console.error('❌ [DashboardApi] Erro details:', error.response?.data);
      console.error('❌ [DashboardApi] Erro status:', error.response?.status);
      throw error;
    }
  }

  // Obter resumo diário
  async getDailySummary(date?: string): Promise<DailySummary> {
    const params: any = {};
    
    if (date) {
      params.date = date;
    }

    const response = await api.get('/client-dashboard/daily-summary', { params });
    return response.data;
  }
}

export default new DashboardApiService();
